import { AdminPageHeader } from '@/components/patterns/admin-page'
import OrganizationForm from '@/components/forms/OrganizationForm'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Building2 } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/organizations/create')({
  beforeLoad: ({ context }) => {
    if (!context.ability.can('create', 'organizations')) throw notFound()
  },
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(organizationQueries.index())

    return { isReadOnly: false }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="max-w-4xl space-y-4">
      <AdminPageHeader icon={Building2} title="Create Organization" />
      <OrganizationForm />
    </div>
  )
}
